<template>
  <div class="filter-rating">
    <div class="filter__options">
      <div class="ratings__wrapper">
        <span class="ratings__rating-placeholder">
          <span
            class="ratings__info"
            v-for="option in filter.options"
            :key="option.label"
          >
            <span v-if="option.value === labelIndex">
              <span class="filter__label">
                {{ generateLabel }}
              </span>
              <span
                class="filter__label filter__option-product-count"
                v-if="option.count"
              >
                ({{ option.count }})
              </span>
            </span>
          </span>
        </span>
        <span
          v-for="option in filter.options"
          :key="`${name}-${option.value}`"
        >
          <input
            class="ratings__input radio-input__input"
            type="radio"
            name="name"
            :value="option.value"
            v-model="selectOption"
            :id="`${name}-${option.value}`"
            @change="optionChangeHandler"
            @update="optionChangeHandler"
            v-show="false"
          >
          <label
            class="ratings__label ratings__label radio-input"
            :class="'ratings__label--index-' + (option.value-1)"
            :for="`${name}-${option.value}`"
            @mouseover="selectStar($event, option.value)"
            @mouseout="resetLabel"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import plpStateComputedMixin from '../../utilities/vueMixins/plpStateComputedMixin/plpStateComputedMixin.js';
  import FilterVue from '../filter/filter.vue';

  const FilterRating = {
    mixins: [
      plpStateComputedMixin
    ],
    components: {
      FilterVue
    },
    props: {
      name: {
        type: String,
        default: null
      },
      updatePageOnChange: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        activeOptions: this.$store.state.productsListPage.filters.find(filter => filter.name === this.name).activeOptions,
        labelIndex: '' + this.activeOptions
      };
    },
    created() {
      this.$store.subscribe(mutation => {
        if (mutation.type === 'productsListPage/updateFiltersState') {
          this.updateFiltersStateHandler();
        }
      });
      this.$store.subscribeAction({
        after: (action) => {
          if (action.type === 'productsListPage/historyPopState') {
            this.updateFiltersStateHandler();
          }
        }
      });
    },
    computed: {
      selectOption: {
        get: function() {
          return this.filter.activeOptions[0]
        },
        set: function (index) {
          let arr = []
          arr.push(index)
          this.activeOptions = arr;
        }
      },
      index() {
        return this.filters.findIndex(filter => filter.name === this.name);
      },
      filter() {
        return this.filters.find(filter => filter.name === this.name);
      },
      generateLabel() {
        let labelString = "";
        if(this.labelIndex == 5) {
          labelString += this.labelIndex + " " + this.$t('filters.rating.stars')
        } else {
          labelString += this.$t('filters.rating.stars.label',[this.labelIndex])
        }
        return labelString;
      }
    },
    methods: {
      optionChangeHandler() {
        this.$store.dispatch('productsListPage/filterUpdate', {
          index: this.index,
          activeOptions: this.activeOptions,
          updatePageOnChange: this.updatePageOnChange
        })
      },
      updateFiltersStateHandler() {
        if (this.filter) {
          this.activeOptions = this.filter.activeOptions;
          this.labelIndex = "" + this.filter.activeOptions[0];
        }
      },
      resetLabel() {
        this.labelIndex = "" + this.activeOptions;
      },
      selectStar(event, index) {
        this.labelIndex = "" + index
      }
    }
  }
  export default FilterRating;
</script>
